<app-preloader [loaderText]="'Loading..'" *ngIf="!taxonomyLoaded" class="w-100 position-fixed preloader-backdrop">
</app-preloader>

<section class="association-select mt-1">
  <app-select-association [viewLocation]="'selectTaxonomy'" (setStep)="setPreviousStep($event);"
    (removeOptions)="removeCopiedOptions($event);" (associationsObj)="updateAssociationsObj($event);"
    (settingsModalOpen)="selectOptions($event);" [optionsToCopySaved]="optionsToCopySaved" [isCopy]="isCopy"
    [isCopyAssociation]="isCopyAssociation" [displayText]="displayText" [displayOption]="displayOption"
    [currentTab]="currentTab"></app-select-association>

  <div class="row align-items-stretch border-top" *ngIf="taxonomyLoaded">
    <as-split direction="horizontal" style="height:auto;">
      <as-split-area size="50" [minSize]="LEFT_MIN_SIZE" [maxSize]="LEFT_MAX_SIZE">
        <div class="col-12 pt-3" id="left_container_id_association_modal">

          <app-tree-search #treeSearch [treeData]="taxonomyData" [showFilter]="false"
            (searchEvent)="captureSearchEvent($event)" (loaderEvent)="setLoaderEvent($event)"
            [location]="'add-association'" class="d-block mb-2">
          </app-tree-search>
          <app-preloader [loaderText]="isFirstTime ? 'Initializing data ...' : 'Searching ...'" *ngIf="isSearching"
            class="preloader-backdrop position-fixed w-100 h-100">
          </app-preloader>

          <app-create-project-tree #tree [documentId]="documentId" [treeNodes]="taxonomyData"
            [isFilterApplied]="isFilterApplied" [searchResultList]="searchResultList"
            [disableDocument]="disableDocument" (hybridSelectedNodes)="onTaxonomyTreeNodeChecked($event)"
            (currentSelectedNode)="onTaxonomyTreeNodeSelected($event);" [viewLocation]="'add-association'">
          </app-create-project-tree>

        </div>
      </as-split-area>
      <as-split-area size="50">
        <div class="col-12 pt-3 bg-lighter panel-right project-authoring taxonomy-preview"
          id="right_container_id_association_modal">
          <app-item-details #itemDetailsComponent [isEditable]="false" [viewLocation]="viewLocation" [modal]="true"
            [showNodeType]="true" [taxonomyData]="taxonomyData[0]" [treeTaxonomyData]="taxonomyData[0]"
            [showAssociation]="showAssocciation" [showAdditionalMetadata]="showAddMetadatas"
            [showExemplar]="showExemplar" [showDocument]="showAssocciation"
            [addedAdditionalMetadata]="itemAdditionalMetadata" [itemExemplars]="itemExemplars" [itemAssets]="itemAssets"
            [itemAssociations]="itemAssociations" [itemLinkedNodes]="itemLinkedNodes" [canPreview]="true"
            [isAllNode]="true" [showNavigation]="false">
          </app-item-details>
        </div>
      </as-split-area>
    </as-split>
  </div>
</section>
